import { FieldArray, Form, Formik } from "formik";
import React, { useCallback, useState } from "react";
import { Button, Card, Modal, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FeatureItemPropTypes } from "../types";
import AddFeatureModal from "./addFeatureModal";
import { getSecurityDataSelector } from "../../../../../store/selector/cmsSelector";
import { uploadFileAction } from "../../editHome/actions";
import addSecurityDataAction from "../actions";

function FeatureItem({ item, index, arrayHelpers, uploadAction, setFieldValue, edit }: FeatureItemPropTypes) {
  const [showEditFeature, setShowEditFeature] = useState<boolean>(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onClickHandler = useCallback(() => {
    setTimeout(() => {
      arrayHelpers.remove(index);
    }, 500);
    handleClose();
  }, [arrayHelpers, index]);

  return (
    <>
      <tr>
        <td>
          <img src={item.image} alt="feature_image" width="100" height="100" className="object-cover" />
        </td>
        <td>
          <p className="fw-bold mb-2">{item.title}</p>
          <p>{item.description}</p>
        </td>
        <td className="text-nowrap align-middle">
          <i aria-hidden="true" className="fa-light p-3 fa-trash-can cursor-pointer" onClick={handleShow} />
          <i aria-hidden="true" className="fa-light p-3 fa-pen-line cursor-pointer" onClick={() => edit && setShowEditFeature(true)} />
          {showEditFeature && (
            <AddFeatureModal
              show={showEditFeature}
              setShow={setShowEditFeature}
              editData={item}
              customArrayHelper={arrayHelpers}
              uploadAction={uploadAction}
              setFieldValue={setFieldValue}
              index={index}
            />
          )}
        </td>
      </tr>
      <Modal
        className="deleteModel"
        show={show}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="signupModalWrapBackdrop"
        centered
      >
        <Modal.Body className="shadow-lg">
          <h6>Are you sure you want to delete?</h6>
          <div className="text-end mt-3">
            <Button variant="outline-danger" onClick={handleClose}>
              Close
            </Button>
            <Button className="ml-2" onClick={onClickHandler} variant="success">
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

function GlobalFeaturesSection() {
  const [whoEdit, setWhoEdit] = useState<boolean>(false);
  const [showAddFeature, setShowAddFeature] = useState<boolean>(false);

  const dispatch = useDispatch();
  const featuresData = useSelector(getSecurityDataSelector);

  const handleGlobalSubmit = (values: any) => {
    const formData = new FormData();
    formData.append("features", JSON.stringify(values.features));
    formData.append("request_type", "features");
    dispatch(addSecurityDataAction(formData, setWhoEdit));
    setWhoEdit(false);
  };

  const uploadLogoFunction = (data: any, fieldValue: any, name: any, setVideoUploading: any) => {
    dispatch(uploadFileAction(data, fieldValue, name, setVideoUploading));
  };

  return (
    <Formik enableReinitialize initialValues={featuresData} onSubmit={handleGlobalSubmit}>
      {({ values, setFieldValue }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 fs-lg ${whoEdit ? "editTitle" : ""}`}>Features Section</h6>
                {whoEdit ? (
                  <button type="submit" className="btn btn-primary">
                    Save <i aria-hidden="true" className="fa-regular fa-floppy-disk ms-1" />
                  </button>
                ) : (
                  <span aria-hidden="true" onClick={() => setWhoEdit(true)} className="btn btn-green">
                    Edit <i aria-hidden="true" className="fa-regular fa-pen-to-square ms-1" />
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  aria-hidden="true"
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${whoEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                />
                <FieldArray
                  name="features"
                  render={(arrayHelpers) => (
                    <>
                      <div className="text-end mb-3">
                        <Button className="btn btn-primary" size="sm" onClick={() => whoEdit && setShowAddFeature(true)}>
                          <i aria-hidden="true" className="fa-regular fa-plus" /> Add
                        </Button>
                      </div>
                      {showAddFeature && (
                        <AddFeatureModal show={showAddFeature} setShow={setShowAddFeature} customArrayHelper={arrayHelpers} uploadAction={uploadLogoFunction} />
                      )}
                      {!!values?.features?.length && (
                        <Table bordered>
                          <tbody>
                            {values.features.map((item: any, index: number) => {
                              return (
                                <FeatureItem
                                  key={item.title}
                                  item={item}
                                  index={index}
                                  arrayHelpers={arrayHelpers}
                                  uploadAction={uploadLogoFunction}
                                  setFieldValue={setFieldValue}
                                  edit={whoEdit}
                                />
                              );
                            })}
                          </tbody>
                        </Table>
                      )}
                    </>
                  )}
                />
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default GlobalFeaturesSection;
